import { Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { ReactNode, useMemo } from "react";

export const TooltipInfo = () => {
  const tooltipTitle: ReactNode = useMemo(() => {
    return (
      <ul className="pl-3 my-0">
        <li>
          <span className="text-sm w-500">Payments</span> — External funds
          received ("from escrow account", "external payments" and "from
          impound" payment methods are excluded).
        </li>
        <li>
          <span className="text-sm w-500">Disbursements</span> — Funds paid out
          to third parties ("to escrow account" disbursement method is
          excluded).
        </li>
      </ul>
    );
  }, []);

  const tooltipStyle: any = useMemo(
    () => ({
      maxWidth: "340px",
    }),
    [],
  );

  return (
    <Tooltip
      placement="top"
      title={tooltipTitle}
      overlayStyle={tooltipStyle}
      overlayClassName="text-sm"
    >
      <QuestionCircleOutlined className="text-md title logo-cursor" />
    </Tooltip>
  );
};
